import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { fetchServices } from '../api/client';
import AsyncContent from '../components/AsyncContent';
import CtaBand from '../components/CtaBand';
import PageHero from '../components/PageHero';
import SectionHead from '../components/SectionHead';
import ServiceBlock from '../components/ServiceBlock';
import { useApi } from '../hooks/useApi';
import { usePageMeta } from '../hooks/usePageMeta';
import { useLanguage } from '../i18n/LanguageProvider';

export default function ServicesPage() {
  const { language, t } = useLanguage();
  const copy = t.services;

  usePageMeta(copy.metaTitle, copy.metaDescription);

  const services = useApi(`services-${language}`, (signal) => fetchServices(language, signal));
  const { hash } = useLocation();

  // Ankarlänkarna pekar på innehåll som laddas asynkront.
  useEffect(() => {
    if (hash && services.status === 'ready') {
      document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [hash, services.status]);

  return (
    <>
      <PageHero eyebrow={copy.heroEyebrow} title={copy.heroTitle} lead={copy.heroLead} />

      <section className="section">
        <AsyncContent state={services}>
          {(items) => items.map((service) => <ServiceBlock key={service.id} service={service} />)}
        </AsyncContent>
      </section>

      <section className="section paper">
        <SectionHead
          eyebrow={copy.engagementHead.eyebrow}
          title={copy.engagementHead.title}
          text={copy.engagementHead.text}
        />
        <div className="steps">
          {copy.engagementSteps.map((step) => (
            <div key={step.num}>
              <span>{step.num}</span>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </div>
          ))}
        </div>
      </section>

      <CtaBand eyebrow={copy.ctaEyebrow} />
    </>
  );
}
